import React, { useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { Table } from "antd";
import { InvoiceSummary } from "@/views/invoice/manage/InvoiceManageTypes";
import { useSummaryModel } from "./summaryModel";
import "@/views/invoice/manage/invoice-style.less";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loadData, setSelectedRowKeys
    } = useSummaryModel(model => [model.dataSource, model.selectedRowKeys]);

    const columns: ColumnsType<InvoiceSummary> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '客户名称',
            dataIndex: 'name',
            align: "center",
            width: 300,
            ellipsis: true,
        },
        {
            title: '客户编码',
            dataIndex: 'code',
            align: "center",
            width: 200,
            ellipsis: true,
        },
        {
            title: '客户类型',
            dataIndex: 'categoryName',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '单据金额',
            dataIndex: 'totalBillAmount',
            align: "center",
            width: 50,
            ellipsis: true,
        },
        {
            title: '已开票金额（实际开票）',
            dataIndex: 'totalInvoiceAmount',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '未开票金额',
            dataIndex: 'totalNotInvoiceAmount',
            align: "center",
            width: 100,
            ellipsis: true,
        }
    ];

    useEffect(() => {
        loadData().then();
    }, [])

    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id]);
        }
    };

    return (
        <Table
            className='radioTableHeight'
            rowKey={record => record.id}
            rowSelection={{
                type: "radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: InvoiceSummary[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id)
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
        />
    )
}

